const Map = () => {
    return (
        <div className="map-component">
            <div className="google-maps-canvas">
                <iframe src="https://www.google.com/maps/embed/v1/place?q=Kate+International&key=AIzaSyBFw0Qbyq9zTFTd-tUY6dZWTgaQzuU17R8"></iframe>
            </div>
        </div>
    )
}

export default Map;